// extracted by mini-css-extract-plugin
module.exports = {"wrap":"title_wrap__V_rUx","wrapSmall":"title_wrapSmall__vFXzB"};